import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { ISettingsState, TogglePermission } from "./types";

const initialState: ISettingsState = {
  permissions: {
    microphone: 'pending',
    camera: 'pending',
  }
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    togglePermission(state, action: PayloadAction<TogglePermission>) {
      const { name, value } = action.payload;

      state.permissions[name] = value;
    },
  },
});

export const { togglePermission } = settingsSlice.actions;

export default settingsSlice.reducer;
